import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import "./HomeDashboard.css";

const InsightsOverview = () => {
  const [threatsData, setThreatsData] = useState([
    { name: "Bushfire", value: 0 },
    { name: "Poaching", value: 0 },
    { name: "Deforestation", value: 0 },
  ]);

  const sensorsData = [
    { name: "Heat Sensor", value: 24 },
    { name: "Smoke Sensor", value: 22 },
    { name: "Sound Sensor", value: 36 },
    { name: "Motion Sensor", value: 18 },
  ];

  const threatColors = ["#EF4444", "#FACC15", "#22C55E"];
  const sensorColors = ["#3B82F6", "#06B6D4", "#8B5CF6", "#60A5FA"];

  useEffect(() => {
    const alertCollections = [
      'drone-bushfire-alerts',
      'drone-deforestation-alerts',
      'drone-poaching-alerts',
      'iot-bushfire-alerts',
      'iot-deforestation-alerts',
      'iot-poaching-alerts'
    ];

    const collectionCounts = {};

    const updateState = () => {
      const threatCounts = {
        bushfire: 0,
        poaching: 0,
        deforestation: 0,
      };

      for (const key in collectionCounts) {
        if (key.includes('bushfire')) {
          threatCounts.bushfire += collectionCounts[key];
        } else if (key.includes('poaching')) {
          threatCounts.poaching += collectionCounts[key];
        } else if (key.includes('deforestation')) {
          threatCounts.deforestation += collectionCounts[key];
        }
      }

      setThreatsData([
        { name: "Bushfire", value: threatCounts.bushfire },
        { name: "Poaching", value: threatCounts.poaching },
        { name: "Deforestation", value: threatCounts.deforestation },
      ]);
    };

    const unsubscribes = alertCollections.map(collectionName => {
      return onSnapshot(collection(db, collectionName), (snapshot) => {
        collectionCounts[collectionName] = snapshot.size;
        updateState();
      }, (error) => {
        console.error(`Error fetching from ${collectionName}:`, error);
      });
    });

    return () => unsubscribes.forEach(unsub => unsub());
  }, []);

  const totalThreats = threatsData.reduce((sum, item) => sum + item.value, 0);

  return (
    <div className="insights-panel">
      <div className="panel-header">
        <h3>Insights</h3>
        <button type="button" className="link-button">View Details</button>
      </div>

      {/* Threats Chart */}
      <div className="chart-section">
        {totalThreats > 0 ? (
          <PieChart width={200} height={200}>
            <Pie
              data={threatsData}
              dataKey="value"
              innerRadius={50}
              outerRadius={70}
              paddingAngle={2}
              label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
              labelLine={false}
            >
              {threatsData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={threatColors[index]} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        ) : (
          <div className="no-data-placeholder" style={{ width: 200, height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9CA3AF' }}>
            No threat data
          </div>
        )}
        <ul className="custom-legend">
          {threatsData.map((entry, index) => (
            <li key={index}>
              <span
                className="legend-color"
                style={{ backgroundColor: threatColors[index] }}
              ></span>
              {entry.name} ({entry.value})
            </li>
          ))}
        </ul>
      </div>

      {/* Sensors Chart */}
      <div className="chart-section">
        <PieChart width={200} height={200}>
          <Pie
            data={sensorsData}
            dataKey="value"
            innerRadius={50}
            outerRadius={70}
            paddingAngle={2}
            label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
            labelLine={false}
          >
            {sensorsData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={sensorColors[index]} />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
        <ul className="custom-legend">
          {sensorsData.map((entry, index) => (
            <li key={index}>
              <span
                className="legend-color"
                style={{ backgroundColor: sensorColors[index] }}
              ></span>
              {entry.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default InsightsOverview;